var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-plan"},[_c('div',{staticClass:"plan-description"},_vm._l((_vm.final_copy),function(copy){return _c('div',[_c('h6',[_vm._v(_vm._s(_vm._f("removeUnderScores")(copy.header_name)))]),_c('p',{domProps:{"innerHTML":_vm._s(copy.value)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }